// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"ReviewSidebar_sidebarContainer__N+qx5","mb32":"ReviewSidebar_mb32__bb0e9","mb16":"ReviewSidebar_mb16__QD8q-","tagsContainer":"ReviewSidebar_tagsContainer__6Jg6h"};